import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Trash2 } from "lucide-react";
import { rp, fmtDate } from "../../lib/format";

export const HeldDialog = ({ open, onOpenChange, held, onResume, onDelete }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="held-dialog">
      <DialogHeader>
        <DialogTitle className="font-display">Transaksi Ditahan</DialogTitle>
        <DialogDescription>Lanjutkan keranjang yang disimpan sementara.</DialogDescription>
      </DialogHeader>
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {held.length === 0 && <p className="text-sm text-muted-foreground py-6 text-center">Tidak ada transaksi ditahan.</p>}
        {held.map((h) => (
          <div key={h.id} className="flex items-center gap-3 rounded-xl border p-3">
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm">{h.items.reduce((a, b) => a + b.qty, 0)} item · <span className="font-mono">{rp(h.items.reduce((a, b) => a + b.qty * b.product.price, 0))}</span></div>
              <div className="text-xs text-muted-foreground">{fmtDate(h.created)}</div>
            </div>
            <Button size="sm" onClick={() => onResume(h)} data-testid={`resume-held-${h.id}`}>Lanjutkan</Button>
            <Button size="icon" variant="ghost" onClick={() => onDelete(h.id)} data-testid={`delete-held-${h.id}`}><Trash2 className="h-4 w-4" /></Button>
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
